import { PRODUCT_CATEGORY } from 'src/constants/product';
import { apiInstance, setRequestHeaders } from './axios';
import { setToken } from './storage';

export const authorizeBixby = (data: ApiOAuthAuthorizeBody): Promise<ApiOAuthAuthorizeResponse> => {
  return apiInstance.post('/oauth/authorize', data);
};

export const userSignUp = (data: ApiUserSignUpBody): Promise<ApiUserSignUpResponse> => {
  return apiInstance.post('/user/signup', data);
};

export const userLogin = async (data: ApiUserLoginBody): Promise<ApiUserLoginResponse> => {
  const tokens: ApiUserLoginResponse = await apiInstance.post('/user/login', {
    ...data,
    loginType: 'MOBILE',
  });
  setRequestHeaders(tokens.accessToken);
  setToken(tokens);
  return Promise.resolve(tokens);
};

export const userQRLogin = async (data: ApiUserQRLoginBody): Promise<ApiUserLoginResponse> => {
  const tokens: ApiUserLoginResponse = await apiInstance.post('/user/qr-login', {
    ...data,
    loginType: 'MOBILE',
  });
  setRequestHeaders(tokens.accessToken);
  setToken(tokens);
  return Promise.resolve(tokens);
};

export const userEmailPasswordChange = (params: ApiUserEmailPasswordChangeParams): Promise<ApiUserEmailPasswordChangeResponse> => {
  // /user/email-password-change?reCaptchaResponse=1234&email=ndt@mhand.net
  return apiInstance.get('/user/email-password-change', {
    params,
  });
};

export const userPasswordChange = (data: ApiUserPasswordChangeBody): Promise<any> => {
  return apiInstance.put('/user/password-change', data);
};

export const userPasswordChangeMe = (data: ApiUserPasswordChangeMeBody): Promise<any> => {
  return apiInstance.put('/user/password-change-me', data);
};

export const reSendVerification = (url: string): Promise<any> => {
  return apiInstance.get(url);
};

export const userPasswordChangeVerification = (params: ApiUserPasswordChangeVerificationParams): Promise<any> => {
  return apiInstance.get('/user/password-change-verification', {
    params,
  });
};

export const userAutoLogin = async (refreshToken: string): Promise<ApiUserAutoLoginResponse> => {
  const tokens: ApiUserAutoLoginResponse = await apiInstance.post('/user/auto-login', {
    loginType: 'MOBILE',
    refreshToken,
  });
  setRequestHeaders(tokens.accessToken);
  setToken(tokens);
  return Promise.resolve(tokens);
};

export const userGeoIp = (): Promise<ApiUserGeoIpResponse> => {
  return apiInstance.get('/user/geoip');
};

export const userRefresh = async (data: ApiUserRefreshBody): Promise<ApiUserRefreshResponse> => {
  const tokens: ApiUserRefreshBody = await apiInstance.post('/user/refresh', {
    ...data,
    loginType: 'MOBILE',
  });
  setRequestHeaders(tokens.accessToken);
  setToken(tokens);
  return Promise.resolve(tokens);
};

export const userProductByOrderId = (params: ApiUserProductByOrderIdParams): Promise<ApiUserProductByOrderIdResponse> => {
  return apiInstance.get('/user/product-by-order-id', {
    params,
  });
};

export const userProducts = (params: ApiUserProductsParams): Promise<ApiUserProductsResponse> => {
  return apiInstance.get('/user/products', {
    params: {
      searchStartDate: '1970-01-01T00:00:00.000Z',
      ...params,
    },
  });
};

export const userProductsActivated = (params?: ApiUserProductsActivatedParams): Promise<ApiUserProductsActivatedResponse> => {
  return apiInstance.get('/user/products-activated', {
    params: params || {
      category: PRODUCT_CATEGORY.KARAOKE,
    },
  });
};

export const userProductsCreated = (params?: ApiUserProductsActivatedParams): Promise<ApiUserProductsActivatedResponse> => {
  return apiInstance.get('/user/products-created', {
    params: params || {
      category: PRODUCT_CATEGORY.KARAOKE,
    },
  });
};

export const userDrop = (): Promise<any> => {
  return apiInstance.delete('/user/drop');
};

export const getCountryList = (): Promise<ApiCountryListResponse> => {
  return apiInstance.get('/country/list');
};

export const getNoticeList = (): Promise<ApiNoticeListResponse> => {
  return apiInstance.get('/notice/list');
};

export const getTermList = (params: ApiTermListParams): Promise<ApiTermListResponse> => {
  return apiInstance.get('/term/list', {
    params,
  });
};
